import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"
import {UserMetadata, UserMetadataInput} from "@irati/types"

import {userMetadataQuery, privateUserMetadataQuery} from "./queries"
import updateUserMetadataMutation from "./mutation/updateUserMetadata"
import updatePrivateUserMetadataMutation from "./mutation/updatePrivateUserMetadata"

class UserMetadataService {
  get(userId: string, options: QueryOptions = {}): Promise<UserMetadata> {
    return client
      .query({
        ...options,
        query: userMetadataQuery,
        variables: {
          userId
        }
      })
      .then(({data}) => data.userMetadata)
      .catch((err) => console.log(err))
  }

  getPrivateMetadata(userId: string, options: QueryOptions = {}): Promise<UserMetadata> {
    return client
      .query({
        ...options,
        query: privateUserMetadataQuery,
        variables: {
          userId
        }
      })
      .then(({data}) => data.userMetadata)
      .catch((err) => console.log(err))
  }

  update(uuid: string, userMetadata: UserMetadataInput, options: MutationOptions = {}): Promise<UserMetadata> {
    userMetadata.uuid = uuid
    return client
      .mutate({...options, mutation: updateUserMetadataMutation, variables: {userMetadata}})
      .then((res) => res.data)
      .catch((err) => console.log(err))
  }

  updatePrivateMetadata(userMetadata: UserMetadataInput, options: MutationOptions = {}): Promise<UserMetadata> {
    // removing unrequired fields for safety on requests
    delete userMetadata.config?.favouriteCategories
    delete userMetadata.config?.uuid
    return client
      .mutate({...options, mutation: updatePrivateUserMetadataMutation, variables: {userMetadata}})
      .then((res) => res.data.updateUserMetadata)
      .catch((err) => console.log(err))
  }
}

const service = new UserMetadataService()

export const getUserMetadata = service.get
export const updateUserMetadata = service.update
export const getPrivateUserMetadata = service.getPrivateMetadata
export const updatePrivateUserMetadata = service.updatePrivateMetadata

export default service
